import { styled } from 'baseui'

export const ModalTitle = styled('h2', ({ $theme }) => ({
  margin: '0 0 1rem 0',
  color: $theme.colors.primary,
  ...$theme.typography.HeadingMedium,

  '@media screen and (min-width: 768px)': {
    ...$theme.typography.HeadingLarge,
  },
}))

export const ModalContent = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
}))

export const ModalSections = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
}))


export const SDModalOverrides = () => ({
  Dialog: {
    style: ({ $theme }) => ({
      width: '75vw',
      borderTopLeftRadius: $theme.borders.radius400,
      borderTopRightRadius: $theme.borders.radius400,
      borderBottomRightRadius: $theme.borders.radius400,
      borderBottomLeftRadius: $theme.borders.radius400,

      '@media screen and (min-width: 768px)': {
        width: '640px',
        height: 'auto',
        minHeight: '380px',
        backgroundColor: $theme.colors.white,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right bottom, center calc(100% + 50px)',
        backgroundSize: 'auto',
      },
    }),
  },
})
